import { Component, computed, input, model } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { pull } from 'lodash';
import { EWidget, TWidgetCustomParameters, widgetConstants } from 'scw-digital-boards-widgets';
import { ArrayIncludesPipe } from '../../../../../core/pipes/array-includes.pipe';
import { AdvancedFilterInputsComponent } from '../../../../../shared/components/advanced-filter/advanced-filter-inputs/advanced-filter-inputs.component';
import { InfoMessageComponent } from '../../../../../shared/components/info-message/info-message.component';
import { IConfigurationsOfAdvancedFilterInputs } from './configure-filters-of-a-mode-panel.interface';

@Component({
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    TranslatePipe,
    MatExpansionPanelTitle,
    AdvancedFilterInputsComponent,
    MatCheckbox,
    ArrayIncludesPipe,
    MatIcon,
    InfoMessageComponent,
  ],
  selector: 'configure-filters-of-a-mode-panel',
  styleUrl: './configure-filters-of-a-mode-panel.component.scss',
  templateUrl: './configure-filters-of-a-mode-panel.component.html',
})
export class ConfigureFiltersOfAModePanelComponent<Widget extends EWidget> {
  public readonly modeName = input.required<string>();
  public readonly configurationsOfAdvancedFilterInputs = input.required<IConfigurationsOfAdvancedFilterInputs[]>();
  public readonly typeBasedConfiguration = input.required<TWidgetCustomParameters[Widget]>();
  public readonly widgetType = input.required<Widget>();
  public readonly filterSuppression = model.required<string[]>();

  public readonly configurationWithAdditionalFields = computed(() => {
    try {
      const modeConstants = widgetConstants[this.widgetType()]
        .filterModes({
          typeBasedConfiguration: this.typeBasedConfiguration(),
        })
        .find(({ name }) => name === this.modeName());

      return this.configurationsOfAdvancedFilterInputs().map((configuration) => {
        return {
          ...configuration,
          isRequired:
            modeConstants?.filters.find(
              ({ identity }) => identity.field === configuration.inputsConfiguration.fixedField!,
            )?.isRequired ?? false,
        };
      });
    } catch {
      return [];
    }
  });

  public readonly areAllFieldsRequired = computed(() => {
    return this.configurationWithAdditionalFields().every(({ isRequired }) => isRequired);
  });

  public toggleCheck(field: string): void {
    if (this.filterSuppression().includes(field)) {
      pull(this.filterSuppression(), field);
    } else {
      this.filterSuppression().push(field);
    }
  }
}
